import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DeleteIconComponent } from './delete-icon.component';
import { CloseIconComponent } from './close-icon.component';
import { EditIconComponent } from './edit-icon.component';
import { TooltipIconComponent } from './tooltip-icon.component';
import { MoveIconComponent } from './move-icon.component';
import { AddIconComponent } from './add-icon.component';
import { ReservationsIconComponent } from './reservations-icon.component';
import { CancelIconComponent } from './cancel-icon.component';
import { EnableServiceIconComponent } from './enable-service-icon.component';
import { TooltipHoverIconComponent } from './tooltip-hover-icon.compoonent';

@NgModule({
  imports: [CommonModule],
  declarations: [
    DeleteIconComponent,
    CancelIconComponent,
    EditIconComponent,
    CloseIconComponent,
    TooltipIconComponent,
    MoveIconComponent,
    AddIconComponent,
    ReservationsIconComponent,
    EnableServiceIconComponent,
    TooltipHoverIconComponent
  ],
  exports: [
    DeleteIconComponent,
    EnableServiceIconComponent,
    CancelIconComponent,
    EditIconComponent,
    CloseIconComponent,
    TooltipIconComponent,
    MoveIconComponent,
    AddIconComponent,
    ReservationsIconComponent,
    TooltipHoverIconComponent
  ]
})
export class AbstractIconsModule {}
